module.exports = __webpack_public_path__ + "static/img/big-2.d041a2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/big-2.png
// module id = QjcN
// module chunks = 1